(() => {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  function setupDrawer() {
    const drawer = document.querySelector('[data-crazy-drawer]');
    const toggle = document.querySelector('[data-crazy-menu-toggle]');
    const close = document.querySelector('[data-crazy-menu-close]');

    if (!drawer || !toggle) {
      return;
    }

    const openDrawer = () => {
      drawer.hidden = false;
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.setAttribute('scroll-lock', '');
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.removeAttribute('scroll-lock');
      window.setTimeout(() => {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, 200);
    };

    toggle.addEventListener('click', () => {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (close) {
      close.addEventListener('click', closeDrawer);
    }

    drawer.addEventListener('click', event => {
      if (event.target === drawer) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  }

  function setupCollectionFilters() {
    document.querySelectorAll('[data-crazy-filter-root]').forEach(root => {
      const buttons = Array.from(root.querySelectorAll('[data-crazy-filter]'));
      const cards = Array.from(root.querySelectorAll('[data-crazy-product-tags]'));
      const countNode = root.querySelector('[data-crazy-results-count]');

      if (!buttons.length || !cards.length) {
        return;
      }

      const applyFilter = value => {
        let visibleCount = 0;
        cards.forEach(card => {
          const tags = (card.getAttribute('data-crazy-product-tags') || '').split('|').filter(Boolean);
          const isVisible = value === 'all' || tags.includes(value);
          card.hidden = !isVisible;
          if (isVisible) {
            visibleCount += 1;
          }
        });

        buttons.forEach(button => {
          const isActive = button.getAttribute('data-crazy-filter') === value;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (countNode) {
          countNode.textContent = String(visibleCount);
        }
      };

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          applyFilter(button.getAttribute('data-crazy-filter') || 'all');
        });
      });

      applyFilter('all');
    });
  }

  function setupGalleries() {
    document.querySelectorAll('[data-crazy-gallery]').forEach(gallery => {
      const mainImage = gallery.querySelector('[data-crazy-main-image]');
      const thumbButtons = Array.from(gallery.querySelectorAll('[data-crazy-thumb]'));

      if (!mainImage || !thumbButtons.length) {
        return;
      }

      thumbButtons.forEach(button => {
        button.addEventListener('click', () => {
          const nextImage = button.getAttribute('data-crazy-image');
          const nextAlt = button.getAttribute('data-crazy-alt') || mainImage.alt;
          if (!nextImage) {
            return;
          }

          mainImage.src = nextImage;
          mainImage.alt = nextAlt;
          thumbButtons.forEach(item => item.classList.remove('is-active'));
          button.classList.add('is-active');
        });
      });
    });
  }

  function setupQuantityButtons() {
    document.querySelectorAll('[data-crazy-qty]').forEach(wrapper => {
      const input = wrapper.querySelector('input[name="quantity"]');
      const minus = wrapper.querySelector('[data-crazy-qty-button="minus"]');
      const plus = wrapper.querySelector('[data-crazy-qty-button="plus"]');

      if (!input) {
        return;
      }

      const step = Number.parseInt(input.step || '1', 10) || 1;
      const min = Number.parseInt(input.min || '1', 10) || 1;

      const update = delta => {
        const current = Number.parseInt(input.value || String(min), 10) || min;
        input.value = String(Math.max(min, current + delta));
      };

      if (minus) {
        minus.addEventListener('click', () => update(-step));
      }

      if (plus) {
        plus.addEventListener('click', () => update(step));
      }
    });
  }

  onReady(() => {
    setupDrawer();
    setupCollectionFilters();
    setupGalleries();
    setupQuantityButtons();
  });
})();
